var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2689 14.2689C15.6755 12.8623 16.5455 10.9191 16.5455 8.77273C16.5455 4.47997 13.0655 1 8.77273 1C4.47997 1 1 4.47997 1 8.77273C1 13.0655 4.47997 16.5455 8.77273 16.5455C10.9191 16.5455 12.8623 15.6755 14.2689 14.2689ZM14.2689 14.2689L19 19M10.96 8.77273H6.59636",
    stroke: "#11334E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoomOut.ee84a352506cbf107cd46cff37d3aac4.svg";
export { ForwardRef as ReactComponent };